"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderInteractiveTest = exports.withTheme = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var themes_1 = require("../themes");
var react_2 = require("@testing-library/react");
var user_event_1 = __importDefault(require("@testing-library/user-event"));
function withTheme(element) {
    return react_1.default.createElement(material_1.ThemeProvider, { theme: themes_1.monarchTheme }, element);
}
exports.withTheme = withTheme;
/**
 * @deprecated The method should not be used use render from @testing-library/react instead, this method cause pipeline performance issues
 */
function renderInteractiveTest(element) {
    return __assign({ user: user_event_1.default.setup({ delay: null, advanceTimers: jest.advanceTimersByTime }) }, (0, react_2.render)(element));
}
exports.renderInteractiveTest = renderInteractiveTest;
